// ASCII SHA-256 (public-domain compact form). Challenges are hex, so non-ASCII never appears.
const SHA_MAX = 2 ** 32;
const SHA_K = [];
const SHA_H0 = [];
(() => {
  const isComposite = {};
  let primeCounter = 0;
  for (let candidate = 2; primeCounter < 64; candidate++) {
    if (!isComposite[candidate]) {
      for (let i = 0; i < 313; i += candidate) isComposite[i] = candidate;
      SHA_H0[primeCounter] = (candidate ** 0.5 * SHA_MAX) | 0;
      SHA_K[primeCounter] = ((candidate ** (1 / 3)) * SHA_MAX) | 0;
      primeCounter++;
    }
  }
})();

function sha256Hex(ascii) {
  function rightRotate(value, amount) {
    return (value >>> amount) | (value << (32 - amount));
  }

  const words = [];
  const asciiBitLength = ascii.length * 8;
  const hash = SHA_H0.slice(0, 8);
  const k = SHA_K;

  ascii += "\x80";
  while ((ascii.length % 64) - 56) ascii += "\x00";
  for (let i = 0; i < ascii.length; i++) {
    words[i >> 2] |= ascii.charCodeAt(i) << (((3 - i) % 4) * 8);
  }
  words[words.length] = (asciiBitLength / SHA_MAX) | 0;
  words[words.length] = asciiBitLength;

  for (let j = 0; j < words.length; ) {
    const w = words.slice(j, (j += 16));
    const oldHash = hash.slice(0, 8);
    const working = hash.slice(0, 8);

    for (let i = 0; i < 64; i++) {
      const w15 = w[i - 15];
      const w2 = w[i - 2];
      const a = working[0];
      const e = working[4];
      const temp1 =
        (working[7] +
          (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) +
          ((e & working[5]) ^ (~e & working[6])) +
          k[i] +
          (w[i] =
            i < 16
              ? w[i]
              : (w[i - 16] +
                  (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) +
                  w[i - 7] +
                  (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) |
                0)) |
        0;
      const temp2 =
        (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) +
        ((a & working[1]) ^ (a & working[2]) ^ (working[1] & working[2]));
      working.pop();
      working.unshift((temp1 + temp2) | 0);
      working[4] = (working[4] + temp1) | 0;
    }

    for (let i = 0; i < 8; i++) hash[i] = (working[i] + oldHash[i]) | 0;
  }

  let result = "";
  for (let i = 0; i < 8; i++) {
    for (let j = 3; j + 1; j--) {
      const b = (hash[i] >> (j * 8)) & 255;
      result += (b < 16 ? "0" : "") + b.toString(16);
    }
  }
  return result;
}

function automatedBrowserReason(env) {
  const target = env || (typeof window !== "undefined" ? window : {});
  const nav = target.navigator || {};
  if (nav.webdriver) return "webdriver";

  const ua = `${nav.userAgent || ""}`;
  if (/HeadlessChrome|PhantomJS|Selenium|Playwright|Puppeteer/i.test(ua)) return "user-agent";

  const win = target.window || target;
  if (
    win.callPhantom ||
    win._phantom ||
    win.__playwright ||
    win.__pwInitScripts ||
    win.__puppeteer ||
    win.domAutomation ||
    win.domAutomationController
  ) {
    return "automation-global";
  }

  const doc = target.document;
  if (doc?.documentElement?.getAttribute?.("webdriver")) return "webdriver-attribute";

  const keys = Object.keys(doc || {}).concat(Object.keys(win || {}));
  if (keys.some((key) => key.startsWith("$cdc_") || key.startsWith("cdc_"))) return "chromedriver";

  return "";
}

function solveCaptcha(challenge, difficulty, fromNonce = 0, limit = 2500) {
  const prefix = "0".repeat(difficulty);
  const end = fromNonce + limit;
  for (let nonce = fromNonce; nonce < end; nonce++) {
    if (sha256Hex(`${challenge}:${nonce}`).startsWith(prefix)) return nonce;
  }
  return null;
}

function solveCaptchaAsync(challenge, difficulty) {
  return new Promise((resolve, reject) => {
    let from = 0;
    const step = () => {
      const found = solveCaptcha(challenge, difficulty, from, 2000);
      if (found !== null) {
        resolve(found);
        return;
      }
      from += 2000;
      if (from > 2_000_000) {
        reject(new Error("verification failed"));
        return;
      }
      setTimeout(step, 0);
    };
    step();
  });
}

export { sha256Hex, solveCaptcha, solveCaptchaAsync, automatedBrowserReason };
